import * as React from 'react';
import CurrencyQuery from '../../Query/Currencies';
import DiscountInputControl, { IDiscountInputControlProps } from './DiscountInput';

class DiscountInput extends React.Component<IDiscountInputControlProps> {

  public render() {
    return (
      <CurrencyQuery>
        {({ currencies }: any) => {
          if (currencies && !currencies.loading && currencies.currencies) {
            return (
              <DiscountInputControl
                {...this.props}
                currencies={currencies.currencies}
              />
            );
          }
          return null;
        }}
      </CurrencyQuery>
    );
  }
}

export default DiscountInput;


// WEBPACK FOOTER //
// ./src/components/Others/DiscountInput/index.tsx